import { formatComp, formatDollars } from '@/lib/useRetailStores';
import { formatUnits, useHomeWholesale, wholesaleLyView, type HomeFilters } from '@/lib/useHomeDashboard';
import { TileMessage, TileShell, TileSkeleton } from './TileShell';
import { TrendChart } from './TrendChart';
import { MUTED_TEXT, NOT_AVAILABLE, deltaClass } from './tileText';

export function HammondsWholesale({ filters }: { filters: HomeFilters }) {
  const { data, isLoading, unavailable } = useHomeWholesale(filters);
  const view = data ? wholesaleLyView(data) : null;
  const delta = view?.delta ?? null;

  return (
    <TileShell
      label="Hammond's"
      title="Hammond's wholesale"
      caption={
        data
          ? `Sage invoices, net of credits, ${data.range.label} vs. last year`
          : 'Sage invoices, net of credits, vs. last year'
      }
    >
      {isLoading ? (
        <TileSkeleton rows={5} />
      ) : unavailable || !data ? (
        <TileMessage>{NOT_AVAILABLE}</TileMessage>
      ) : (
        <div className="flex flex-col gap-3">
          <div>
            <div className="text-[30px] font-semibold leading-tight text-amp-ink dark:text-amp-dark-ink">
              {formatDollars(data.total_ty)}
            </div>
            {!data.ly_note && (
              <div className="text-[13px]">
                <span className={deltaClass(delta)}>{formatComp(delta)}</span>{' '}
                <span className={MUTED_TEXT}>vs {formatDollars(data.total_ly)} last year</span>
              </div>
            )}
            <div className="mt-1 text-[13px] text-amp-ink dark:text-amp-dark-ink">
              {formatUnits(data.invoices_ty)} invoices, avg {formatDollars(data.avg_invoice_ty)}{' '}
              {!data.ly_note && (
                <span className={MUTED_TEXT}>
                  (last year {data.invoices_ly == null ? '--' : formatUnits(data.invoices_ly)}, avg{' '}
                  {formatDollars(data.avg_invoice_ly)})
                </span>
              )}
            </div>
            {data.ly_note && <div className={`mt-1 text-[12px] ${MUTED_TEXT}`}>{data.ly_note}</div>}
          </div>
          {data.points.length > 0 && (
            <TrendChart
              points={data.points}
              grain="day"
              ariaLabel="Wholesale invoiced sales, this year versus last year"
              height={140}
              showLegend={false}
              hideLy={!view?.showLyChart}
            />
          )}
        </div>
      )}
    </TileShell>
  );
}
